<template>
  <div class="dg-page">
    <div class="bg-[#fff] p-[20] mb-[16] shadow" v-if="$slots.leftBtns && timeTypeOptions[0].length">
      <div class="flex items-center" v-if="timeTypeOptions[0].length">
        <el-time-type ref="timeType" @change="handleTime" v-model="timeType" :data="timeTypeOptions" placeholder="选择时间">
        </el-time-type>
        <p v-if="formattedTime && formattedTime === 'customize'" class="pl-[8]">
          <el-date-picker size="small" range-separator="至" type="datetimerange" start-placeholder="开始日期"
            end-placeholder="结束日期" v-model="daterange"> </el-date-picker>
        </p>
        <span class="pl-[16] t-[12] t-[#000000]" v-else>{{ formattedTime }}</span>
      </div>
    </div>
    <div class="bg-[#fff] p-[20]">
      <div class="pb-[10]" v-if="tips.msg">
        <transition name="el-zoom-in-top">
          <el-alert @close="
            () => {
              tips.msg = '';
            }
          " :title="tips.msg" :type="tips.type" show-icon>
          </el-alert>
        </transition>
      </div>
      <div class="search-box" v-if="showSearch">
        <div class="left-area">
          <slot v-if="$slots.leftBtns" name="leftBtns"></slot>
          <div v-else>
            <div class="flex items-center" v-if="timeTypeOptions[0].length">
              <el-time-type ref="timeType" @change="handleTime" v-model="timeType" :data="timeTypeOptions"
                placeholder="选择时间"> </el-time-type>
              <p v-if="formattedTime && formattedTime === 'customize'" class="pl-[8]">
                <el-date-picker size="small" range-separator="至" type="datetimerange" start-placeholder="开始日期"
                  end-placeholder="结束日期" v-model="daterange"> </el-date-picker>
              </p>
              <span class="pl-[16] t-[12] t-[#000000]" v-else>{{ formattedTime }}</span>
            </div>
          </div>
        </div>
        <div class="right-area" v-if="showSearchRightArea">
          <el-search-input ref="searchInputRef" v-if="showSearchInput" :searchGroups="searchGroups"
            @handleSearch="handleSearch"></el-search-input>
          <div v-if="showfiltersBtns" class="right-action-btns">
            <el-tooltip class="item" effect="dark" content="重置" placement="top">
              <el-button icon="el-icon-refresh" size="small" plain class="icon-btns" @click="handleReset"
                :loading="loadingSearch" v-show="showLoading"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="自定义列表" placement="top">
              <el-button icon="el-icon-setting" size="small" plain class="icon-btns" @click="handleSetting"
                v-show="showSetting"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导出" placement="top">
              <el-button v-show="showExport" icon="el-icon-upload2" size="small" plain class="icon-btns"
                @click="handleExport"></el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="导入" placement="top">
              <el-button v-show="showImport" icon="el-icon-download" size="small" plain class="icon-btns"
                @click="handleImport"></el-button>
            </el-tooltip>
            <slot name="rightActionBtns"></slot>
          </div>
        </div>
      </div>
      <!-- 搜索条件回显 -->
      <div v-if="searchTags.length" class="search-bar">
        <el-search-bar :total="pagination.total" :searchTags="searchTags" @handleClose="handleCloseTag"
          @handleClear="handleClearTag"></el-search-bar>
      </div>

      <el-search-table :key="Math.random()" :columns="filterColumns()" :showSelection="showSelection"
        :showIndex="showIndex" :tableData="tableData" :pagination="pagination" @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange" @handleSelectionChange="handleSelectionChange"
        :tableLoading="loadingSearch">
        <!-- :tableLoading="loadingSearch" -->
        <!-- 自定义列 -->
        <template v-for="item in slots" v-slot:[item]="scope">
          <slot :name="item" v-bind="scope"></slot>
        </template>
        <!-- 自定义表头 -->
        <template v-for="(item, index) in customHeader" #[item.header]>
          <div class="flex items-center">
            <span class="pr-[4]">{{ item.label }}</span>
            <el-dropdown trigger="click" :tabindex="index" @visible-change="handleVisibleChange">
              <span class="el-dropdown-link">
                <i class="icon cursor-pointer status-icon-hover">&#xe6b0;</i>
              </span>
              <el-dropdown-menu slot="dropdown" :hide-on-click="false" class="table-header-dropdown">
                <div class="checkbox-pop">
                  <el-checkbox-group v-model="item.checkStatus" @change="(val) => handleCheckboxStatus(val, item)"
                    :max="item.isMultiple ? 999 : 1">
                    <!-- <div class="checkbox-item">
                      <el-checkbox label="">全部</el-checkbox>
                    </div> -->
                    <div class="checkbox-item" v-for="(curr, index) in item.statusAll" :key="index">
                      <el-checkbox :label="curr.key.toString()">{{ curr.value }}</el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
        <!-- <template #empty>
          <div class="text-center py-[50]">
            <p><img src="../assets/img/public/empty.png" class="w-[166]" alt="" /></p>
            <p class="pt-[22] leading-[20] t-[#909399] t-[14]">{{ emptyMsg || "暂无数据" }}</p>
          </div>
        </template> -->
      </el-search-table>
    </div>
    <!-- <div class="text-center pt-[32] pb-[16]">
      <el-button class="w-[160]" size="small" @click="routerBack">返回</el-button>
    </div> -->
    <!-- 设置弹窗 -->
    <el-dialog custom-class="setting-dialog" :show-close="false" :visible.sync="dialogVisible" width="700px">
      <template slot="title">
        <div class="dialog-title">
          <div class="title">自定义列表</div>
          <i class="el-icon-circle-close dialog-close-icon" @click="dialogVisible = false"></i>
        </div>
      </template>
      <div class="dialog-content">
        <div class="checked-box">选中：{{ checkList.length }}/{{ checkboxs.length }}。清除缓存或更换浏览器，自定义列表失效。</div>
        <el-checkbox-group class="checkbox-group" v-model="checkList">
          <div class="checkbox-item" v-for="(item, index) in checkboxs" :key="index">
            <el-checkbox :label="item.prop" :disabled="item.disabled">{{ item.label }}</el-checkbox>
          </div>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false" plain>取消</el-button>
        <el-button size="small" type="primary" @click="handleSubmitSetting">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import { formatDate } from "@/assets/js/utils";
//
function formatDate_(start, end) {
  return [formatDate(start).slice(0, 11) + " 00:00:00", formatDate(end).slice(0, 11) + " 23:59:59"].toString();
}
// function formatDate_(start, end) {
//   return [formatDate(start).slice(0, 11) + ' 00:00:00', formatDate(end)].toString()
// }
export default {
  mixins: [mixin],
  name: "dg-page",
  props: {
    api: Object,

    columns: Array,
    formData: {
      type: Object,
      default: () => { },
    },
    formItems: Array,
    defaultFormData: Array,
    // 是否显示整个筛选区域
    showSearch: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧筛选区域
    showSearchRightArea: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧筛选输入框
    showSearchInput: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧操作按钮图标
    showfiltersBtns: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧重置按钮图标
    showLoading: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧自定义列表设置按钮图标
    showSetting: {
      type: Boolean,
      default: true,
    },
    // 是否显示右侧导出按钮图标
    showExport: {
      type: Boolean,
      default: false,
    },
    // 是否显示右侧导入按钮图标
    showImport: {
      type: Boolean,
      default: false,
    },
    // 是否显示列表复选框
    showSelection: {
      type: Boolean,
      default: false,
    },
    // 是否显示列表序号
    showIndex: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      tips: {
        msg: "",
        type: "error",
      },
      loadingSearch: false,
      daterange: [],
      tableData: [],
      searchTags: [],
      timeType: [],
      pagination: {
        pageNo: 1, // 页数
        pageSize: 10, // 条数
        total: 0,
      },
      timeTypeOptions: [
        [],
        [
          {
            value: (() => {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime());
              return formatDate_(start, end);
            })(),
            label: "今天",
          },
          {
            value: (() => {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              end.setTime(end.getTime() - 3600 * 1000 * 24 * 1);
              return formatDate_(start, end);
            })(),
            label: "昨天",
          },
          {
            value: (() => {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return formatDate_(start, end);
            })(),
            label: "最近一周",
          },
          {
            value: (() => {
              let end = new Date();
              let start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return formatDate_(start, end);
            })(),
            label: "最近一个月",
          },
          {
            value: "customize",
            label: "自定义",
          },
        ],
      ],
      customHeader: [],
      dialogVisible: false,
      checkList: [], //自定义列表
      checkboxs: [], //自定义列表复选框
      currentForm: {},
      statusCheckoutVals: [],

      statusCheckoutItem: {},
    };
  },

  computed: {
    formattedTime() {
      if (this.timeType[1]) {
        return this.timeType[1].split(",").join(" - ");
      }
      return "";
    },
    // 自定义列表行列内容
    slots() {
      let arr = [];
      this.columns.forEach((item) => {
        if (item.slotProp) {
          arr.push(item.slotProp);
        }
      });
      return arr;
    },
    // 自定义列表头
    slotsHeader() {
      let arr = [];
      function findHeader(arrs) {
        arrs.forEach((item) => {
          if (item.child) {
            findHeader(item.child);
          } else {
            if (item.header) {
              arr.push({ header: `${item.header}Header`, label: item.label, currentKey: item.currentKey });
            }
          }
        });
      }
      // this.columns.forEach((item) => {
      //   if (item.header) {
      //     arr.push({ header: `${item.header}Header`, label: item.label, currentKey: item.currentKey });
      //   }
      // });
      findHeader(this.columns);
      return arr;
    },
    // 筛选输入框组合
    searchGroups() {
      if (!this.showSearchInput || !this.showSearch) return;
      let arr = [];
      this.formItems &&
        this.formItems.forEach((item) => {
          if (item.type == "input") {
            arr.push({ key: item.key, label: item.label });
          }
        });
      return arr;
    },
  },

  watch: {
    daterange(val) {
      this.resetTimeType();
      if (!this.timeType[0]) {
        this.timeType[0] = this.timeTypeOptions[0];
      }
      let [key1, key2] = this.timeType[0].split(",");
      if (val) {
        this.currentForm[key1] = formatDate(val[0]) ? formatDate(val[0]) : "";
        this.currentForm[key2] = formatDate(val[1]) ? formatDate(val[1]) : "";
      } else {
        this.currentForm[key1] = "";
        this.currentForm[key2] = "";
      }
      this.getList();
    },
    columns: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.handleInitCheckBox(newVal);
        }
      },
    },
    formData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length) {
          this.currentForm = { ...newVal };
        }
      },
    },
  },
  filters: {
    time: (val) => {
      if (val) {
        return val.split(",").join(" - ");
      }
      return "";
    },
  },

  methods: {
    // 列表过滤行列
    filterColumns() {
      let LOCALSTORAGE_KEY = window.location.hash ? window.location.hash : window.location.host;
      const _columns = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) || "[]");
      // let columns = JSON.parse(JSON.stringify(this.columns));
      if (_columns && _columns.length) {
        let r = [];
        this.columns.forEach((item) => {
          if (item.child) {
            let a = {
              ...item,
              child: [],
            };
            r.push(a);
            item.child.forEach((_item) => {
              if (_columns.indexOf(_item.prop) > -1) a.child.push(_item);
            });
            return true;
          } else {
            if (_columns.indexOf(item.prop) > -1 || item.prop == "action") {
              r.push(item);
            }
          }
        });
        return r;
        // return columns.filter((item) => _columns.indexOf(item.prop) > -1 || item.prop == "action");
      } else {
        return this.columns;
      }
    },
    // 列表复选框事件
    handleSelectionChange(val) {
      this.$emit("handleSelectionChange", val);
    },
    // 导出
    handleExport() {
      this.$emit("handleExport", { ...this.currentForm, ...this.pagination });
    },
    // 导入
    handleImport() {
      this.$emit("handleImport", { ...this.currentForm, ...this.pagination });
    },
    // 确认提交设置弹窗
    handleSubmitSetting() {
      this.dialogVisible = false;
      let LOCALSTORAGE_KEY = window.location.hash ? window.location.hash : window.location.host;
      localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(this.checkList));
      this.filterColumns();
    },
    // 删除单个搜索条件
    handleCloseTag(tag) {
      this.pagination.pageNo = 1;
      const index = this.customHeader.findIndex((item) => item.currentKey == tag.key);
      if (index > -1) {
        let _item = this.customHeader[index];
        const find = _item.statusAll.find((item) => item.value == tag.label);
        let checkStatus = _item.checkStatus.filter((curr) => curr != find.key);
        this.currentForm[tag.key] = checkStatus.toString() || "";
        let obj = _item;
        obj.checkStatus = checkStatus;
        this.$set(this.customHeader, index, obj);
      } else {
        this.currentForm[tag.key] = "";
      }
      this.getList();
    },
    // 清空搜索条件
    handleClearTag() {
      this.searchTags = [];
      this.pagination.pageNo = 1;
      Object.keys(this.currentForm).forEach((key) => {
        if (this.defaultFormData && this.defaultFormData.includes(key)) return;
        this.currentForm[key] = "";
      });
      if (this.customHeader.length) {
        let arr = [];
        this.customHeader.forEach((item) => {
          arr.push({
            ...item,
            checkStatus: [],
          });
        });
        this.customHeader = [];
        arr.forEach((item) => {
          this.customHeader.push({ ...item });
        });
      }
      if (this.$refs.searchInputRef) {
        this.$refs.searchInputRef.searchInput = "";
        this.$refs.searchInputRef.searchInput2 = "";
        this.$refs.searchInputRef.searchContent = [];
      }
      this.getList();
    },
    // 选择状态搜索
    handleCheckboxStatus(val, row) {
      this.statusCheckoutVals = val;
      this.statusCheckoutItem = { ...row };
    },
    // 状态搜索事件
    handleVisibleChange(val) {
      if (!val) {
        this.searchTags = [];
        this.statusCheckoutVals.forEach((item, index) => {
          if (typeof item == "string" && item == "") {
            this.searchTags.push({ label: "全部", key: this.statusCheckoutItem.currentKey, id: index + 1 });
          } else {
            const curr = this.statusCheckoutItem.statusAll.find((cur) => cur.key.toString() == item);
            this.searchTags.push({ label: curr.value, key: this.statusCheckoutItem.currentKey, id: index + 1 });
          }
        });
        let res = this.statusCheckoutVals.findIndex((item) => item == "") > -1 ? "" : this.statusCheckoutVals.toString();
        this.$set(this.currentForm, this.statusCheckoutItem.currentKey, res);
        this.getList();
      }
    },
    // 打开自定义列弹窗
    handleSetting() {
      this.handleInitCheckBox(this.columns);
      this.dialogVisible = true;
    },
    // 初始化自定义列表多选框
    handleInitCheckBox(columns) {
      this.checkboxs = columns
        .map((el) => {
          if (el.child) {
            return el.child;
          } else {
            return el;
          }
        })
        .flat(2)
        .filter((item) => item.prop !== "action");
      // this.checkboxs = columns.filter((item) => item.prop !== "action");

      let LOCALSTORAGE_KEY = window.location.hash ? window.location.hash : window.location.host;
      const _columns = JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) || "[]");
      if (_columns && _columns.length) {
        const deffs = _columns.concat(this.checkboxs).filter((v, i, arr) => {
          return arr.indexOf(v) === arr.lastIndexOf(v);
        });
        if (deffs.length > 0 && this.checkboxs.every((item) => deffs.includes(item.prop) == -1)) {
          this.checkList = this.checkboxs.filter((item) => !item.disabled).map((item) => item.prop);
          localStorage.clear();
          localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(this.checkList));
        } else {
          this.checkList = _columns;
        }
      } else {
        this.checkList = this.checkboxs.map((item) => item.prop);
        localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(this.checkList));
      }
    },
    // 列表重置
    handleReset() {
      this.timeType = [];
      if (this.$refs.searchInputRef) {
        this.$refs.searchInputRef.searchInput = "";
        this.$refs.searchInputRef.searchInput2 = "";
        this.$refs.searchInputRef.searchContent = [];
      }
      this.$refs.timeType && this.$refs.timeType.reset();
      this.searchTags = [];
      let resetHeaderArr = [];
      this.customHeader.forEach((item) => {
        item.checkStatus = [];
        resetHeaderArr.push(item);
      });
      this.customHeader = resetHeaderArr;
      this.pagination.pageNo = 1;
      // Object.keys(this.currentForm).forEach((key) => {
      //   if (this.defaultFormData && this.defaultFormData.includes(key)) return;
      //   this.currentForm[key] = "";
      // });
      Object.keys(this.formData).forEach((key) => {
        this.currentForm[key] = this.formData[key];
      });

      this.getList();
    },
    /**
     * @author 伟健 / 张
     * @name 重置时间
     */
    resetTimeType() {
      let option = this.timeTypeOptions[0];
      if (option) {
        option.forEach((el) => {
          if (el.value) {
            let [key1, key2] = el.value.split(",");
            this.currentForm[key1] = "";
            this.currentForm[key2] = "";
          }
        });
      }
    },
    /**
     * @author 伟健 / 张
     * @name 选择时间类型
     */
    handleTime(val) {
      this.resetTimeType();
      if (val[0] && val[1] && val[1] !== "customize") {
        let [key1, key2] = val[0].split(",");
        let [val1, val2] = val[1].split(",");
        this.currentForm[key1] = val1 + "00:00:00";
        this.currentForm[key2] = val2;
        this.getList();
      }
    },
    /**
     * @author 伟健 / 张
     * @name 搜索
     * @param
     * @return
     */
    handleSearch(params) {
      if (!Object.keys(params).length) return;
      this.searchTags = [];
      this.pagination.pageNo = 1;
      let paramsArr = [];
      Object.keys(params).forEach((key, index) => {
        paramsArr.push({ [key]: params[key] });
        this.searchTags.push({ label: params[key], key, id: index + 1 });
      });
      this.currentForm = { ...this.formData };
      this.currentForm = { ...this.currentForm, ...params };
      this.getList();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.getList();
    },

    /**
     * @author 伟健 / 张
     * @name 列表
     */
    getList() {
      this.loadingSearch = true;
      if (!this.api.list) return;
      let data = { ...this.currentForm, ...this.pagination };
      let d = {
        url: this.api.list.url,
        self: this,
        data: {},
        success: (res) => {
          if (res) {
            try {
              if (this.api.list.after) {
                res = this.api.list.after(res);
              }
              this.tableData = res.result || [];
              this.pagination.total = res.totalItems || 0;
              this.loadingSearch = false;
            } catch (e) {
              console.log(e);
            }
          }
        },
        fail: () => {
          this.loadingSearch = false;
        },
      };
      d.data = data;
      // if (this.api.list.method == 'post') {
      //   d.data = data
      // }
      // if (this.api.list.method == 'get') {
      //   d.data = data
      // }
      ajax[this.api.list.method || "post"](d);
    },

    /**
     * @author 伟健 / 张
     * @name 订单状态集合
     */
    async getStatus() {
      // [{url,key,isMultiple},]
      let _this = this;
      if (_this.api.status && _this.api.status.length) {
        _this.customHeader = [];
        let _slotsHeader = _this.slotsHeader;
        let headers = [];
        for (let i = 0; i < _this.api.status.length; i++) {
          const item = _this.api.status[i];
          let current = _slotsHeader.find((cur) => cur.currentKey == item.key);
          if (item.url == "/customer/status") {
            headers.push({
              label: current.label,
              header: current.header,
              statusAll: item.statusAll,
              isMultiple: item.isMultiple,
              currentKey: current.currentKey,
              checkStatus: [],
            });
          } else {
            if (item.method == "get") {
              let res = await ajax.get({
                url: item.url,
                data: item.params || {},
                self: this,
                success: () => { },
                fail: () => { },
              });
              if (res.result) {
                let _arr = [];
                const arr = item.success ? item.success(res.result) : res.result;
                arr.forEach((el) => {
                  _arr.push(el);
                });
                headers.push({
                  label: current.label,
                  header: current.header,
                  statusAll: _arr,
                  isMultiple: item.isMultiple,
                  currentKey: current.currentKey,
                  checkStatus: [],
                });
              }
            } else {
              let res = await ajax.post({
                url: item.url,
                data: item.params || {},
                self: this,
                success: () => { },
                fail: () => { },
              });
              if (res) {
                let _arr = [];
                const arr = item.success ? item.success(res) : res.data;
                arr.forEach((el) => {
                  _arr.push(el);
                });
                headers.push({
                  label: current.label,
                  header: current.header,
                  statusAll: _arr,
                  isMultiple: item.isMultiple,
                  currentKey: current.currentKey,
                  checkStatus: [],
                });
              }
            }
          }
        }
        this.customHeader = headers;
      }
    },
    /**
     * @author 伟健 / 张
     * @name 提取时间/
     */
    extractionTime() {
      if (this.formItems) {
        this.formItems.forEach((el) => {
          if (el.type == "date") {
            this.timeTypeOptions[0].push({
              value: el.key,
              label: el.label,
            });
          }
          if (el.slotProp) {
            this.slots.push(el.slotProp);
          }
        });
      }
    },
  },
  mounted() {
    let time = null;
    let dgFormDialogOpen = null;

    // 监听弹窗打开 dg-form-dialog 如： 修改发票，防止多个loding 显示
    Mirror.watch("dg_form_dialog_open", () => {
      dgFormDialogOpen = true;
    });
    // 监听弹窗关闭 dg-form-dialog
    Mirror.watch("dg_form_dialog_close", () => {
      dgFormDialogOpen = false;
    });

    Mirror.watch(["table_success_tips_open", "table_success_tips"], (key, tips) => {
      if (dgFormDialogOpen) return;
      if (tips.msg) {
        this.tips.msg = tips.msg;
        this.tips.type = tips.type;
        clearInterval(time);
        setTimeout(() => {
          this.tips.msg = "";
        }, 3000);
      } else {
        this.tips.msg = "操作失败";
        this.tips.type = "error";
      }
    });
  },
  created() {
    this.extractionTime();
    this.getList();
    this.getStatus();
  },
};
</script>

<style lang="less" scoped>
.dg-page {
  .search-box {
    display: flex;
    justify-content: space-between;

    .left-area {
      display: flex;
      align-items: center;
    }

    .right-area {
      display: flex;
      align-items: center;

      .right-action-btns {
        margin-left: 8px;

        .icon-btns {
          font-size: 16px !important;
          padding: 7px !important;

          &:hover,
          &:focus,
          &:active {
            border-color: #c3cad9 !important;
          }
        }

        button+button {
          margin-left: 4px !important;
        }
      }
    }
  }

  .dialog-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
      font-size: 16px;
      color: #303133;
      line-height: 20px;
    }

    .dialog-close-icon {
      font-size: 18px;
      cursor: pointer;
    }
  }

  .dialog-content {
    .checked-box {
      width: 100%;
      background: #fafafc;
      height: 38px;
      line-height: 38px;
      box-sizing: border-box;
      padding-left: 16px;
      font-size: 12px;
      color: #000000;
      border-bottom: 1px solid #d2d6ea;
    }

    .checkbox-group {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      padding: 19px 20px;

      .checkbox-item {
        flex-basis: 165px;
        height: 56px;
        display: flex;
        box-sizing: border-box;
        padding: 0 8px;
        justify-content: flex-start;
        align-items: center;

        .el-checkbox__label {
          font-size: 12px;
          color: #000000;
        }

        .el-checkbox__input.is-checked+.el-checkbox__label {
          color: var(--primary-color) !important;
        }
      }
    }
  }

  .dialog-footer {
    .el-button--small {
      padding: 9px 10px;
    }
  }
}

/deep/ .el-dialog {
  border-radius: 6px;
}

// 列表行列展示弹窗开始
/deep/ .el-dialog__header {
  padding: 16px !important;
  border-bottom: 1px solid #c3cad9;
}

/deep/ .el-dialog__body {
  padding: 0;
}

/deep/ .el-dialog__footer {
  border-top: 1px solid #c3cad9;
  padding: 15px 16px;
}

.checkbox-pop {
  box-sizing: border-box;
  padding: 8px 16px;

  .checkbox-item {
    box-sizing: border-box;
    padding: 8px 0;
  }

  ::v-deep .el-checkbox__label {
    padding-left: 8px;
    display: inline-block;
    vertical-align: text-top;
    max-width: 190px;
    white-space: normal;
  }
}

.status-icon-hover {
  &:hover {
    color: var(--primary-color);
  }
}

.shadow {
  border-radius: 4px;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.12), 0px 8px 12px -4px rgba(0, 0, 0, 0.12), 0px 4px 4px -2px rgba(0, 0, 0, 0.05), inset 0px -2px 0px 0px rgba(0, 0, 0, 0.08);
}

.table-header-dropdown[x-placement^="bottom"] {
  max-height: 300px;
  overflow-y: auto;
}
</style>
 <style>.bg-\[\#fff\] {
    background-color: #fff
}
.p-\[20\] {
    padding: 20px
}
.mb-\[16\] {
    margin-bottom: 16px
}
.pl-\[8\] {
    padding-left: 8px
}
.pl-\[16\] {
    padding-left: 16px
}
.t-\[12\] {
    font-size: 12px
}
.t-\[\#000000\] {
    color: #000000
}
.pb-\[10\] {
    padding-bottom: 10px
}
.pr-\[4\] {
    padding-right: 4px
}
.py-\[50\] {
    padding-top: 50px;
    padding-bottom: 50px
}
.w-\[166\] {
    width: 166px
}
.pt-\[22\] {
    padding-top: 22px
}
.leading-\[20\] {
    line-height: 20px
}
.t-\[\#909399\] {
    color: #909399
}
.t-\[14\] {
    font-size: 14px
}
.pt-\[32\] {
    padding-top: 32px
}
.pb-\[16\] {
    padding-bottom: 16px
}
.w-\[160\] {
    width: 160px
}
.flex {
    display: flex
}
.items-center {
    align-items: center
}
.cursor-pointer {
    cursor: pointer
}
.table {
    display: table
}
.text-center {
    text-align: center
}</style>